import React, { useState, useEffect } from "react";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const TFOption = (props) => {
  let [labels, setLabels] = useState([]);

  useEffect(() => {
    console.log("props", props);
    if (props.statePair) {
      setLabels(props.statePair.split("|"));
    } else {
      setLabels(["True", "False"]);
    }
  }, [props]);
  return (
    <ButtonGroup size="small" sx={{ paddingTop: "2px" }}>
      <Button
        size="small"
        sx={{
          borderTopLeftRadius: 20,
          borderBottomLeftRadius: 20,
          lineHeight: 1.5,
          borderColor:
            props.selected == true || props.selected == "true"
              ? "#DB8829"
              : "#c9c9c9",
          textTransform: "inherit",
          backgroundColor:
            props.selected == true || props.selected == "true"
              ? "#DB8829"
              : "#FFFFFF",
          color:
            props.selected == true || props.selected == "true"
              ? "#FFFFFF"
              : "#DB8829",
          fontWeight: "600",
          fontSize: "0.8rem",
          "@media (min-width: 1636px)": {
            fontSize: "1.2rem",
          },
          
        }}
        onClick={() => {
          props.press(true);
        }}
      >
        {labels[0] ? labels[0].trim() : ""}
      </Button>
      <Button
        sx={{
          borderTopRightRadius: 20,
          borderBottomRightRadius: 20,
          lineHeight: 1.5,
          borderColor:
            props.selected == false || props.selected == "false"
              ? "#DB8829"
              : "#c9c9c9",
          textTransform: "inherit",
          backgroundColor:
            props.selected == false || props.selected == "false"
              ? "#DB8829"
              : "#FFFFFF",
          color:
            props.selected == false || props.selected == "false"
              ? "#FFFFFF"
              : "#DB8829",
          fontWeight: "600",
          fontSize: "0.8rem",
          "@media (min-width: 1636px)": {
            fontSize: "1.2rem",
          },
          
        }}
        onClick={() => {
          props.press(false);
        }}
      >
        {labels[1] ? labels[1].trim() : ""}
      </Button>
    </ButtonGroup>
  );
};

export default TFOption;
